import styled from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

export const Label = styled.div<IWithSize>`
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  color: #696a6d;
  margin-right: ${({ size }) => (size ? 7 * size : 7)}px;
`
